import { AbsgArrayHelper, DefaultAzureHeaders, EnvironmentConfiguration, LogService } from '@absg/angular-common';
import { MSODataQuery, ODataSearchList } from '@absg/angular-components';
import { PhysiciansODataApi } from '@absg/api-party';
import { BaseService, Physician } from '@absg/nim-client-shared';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PhysicianService extends BaseService {
  endpointUrl: string;
  headers: HttpHeaders;

  constructor(
    private environment: EnvironmentConfiguration,
    private azureHeaderFactory: DefaultAzureHeaders,
    private physiciansODataApi: PhysiciansODataApi,
    loggingService: LogService,
  ) {
    super(loggingService);
    this.setupService();
  }

  setupService(): void {
    this.endpointUrl = this.environment.apis.physician.endpointUrl;
    this.headers = this.azureHeaderFactory.createHeaders();
  }

  getPhysiciansById(physicianIds: number[]): Observable<Physician[]> {
    const results: Physician[] = [];

    if (physicianIds.length === 0) {
      return of([]);
    }

    const query = new MSODataQuery({
      searchFields: [],
      pageNumber: 1,
      itemsPerPage: 100,
      excludeCount: true,
      inSearch: [new ODataSearchList('PhysicianPartyId', physicianIds)],
    });

    return this.physiciansODataApi.getPhysiciansLookupOData({ search: query.toString() })
      .pipe(
        map(odataResult => {
          const physicians = odataResult.value;
          if (physicians && physicians.length > 0) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            physicians.forEach((physician: any) => {
              results.push(new Physician(physician.physicianPartyId, physician.firstName, physician.lastName, physician.physicianIdNumber));
            });
          }
          return results;
        }),
        catchError((response: HttpErrorResponse) => this.handleErrorResponse(response)),
      );
  }

  static filterData(physicians: Physician[], query: string): Physician[] {
    {
      return physicians.filter((physician: Physician) => {
        // return all physicians if no search term is entered
        if (query.length === 0) {
          return true;
        }

        // replace `/` and `-` with space
        const searchTerms = query.replace('/', ' ').replace('-', ' ');

        // check if any of the search terms match the searchable fields
        let isFound = false;
        isFound = isFound || (searchTerms.length && (
          physician.firstName.toLowerCase().includes(searchTerms.toLowerCase()) ||
          physician.lastName.toLowerCase().includes(searchTerms.toLowerCase()) ||
          (physician.physicianId !== null && physician.physicianId.toLowerCase().includes(searchTerms.toLowerCase()))));
        return isFound;
      });
    }
  }

  static sortList(physicians: Physician[]): Physician[] {
    const physicianSortedList: Physician[] = AbsgArrayHelper.sortBy(physicians, x => [x.lastName?.toLowerCase(), x.firstName?.toLowerCase(), x.middleName?.toLowerCase()]);
    return physicianSortedList;
  }
}
